export default __webpack_public_path__ + "static/media/assembly-logo.85f09447.svg";